export const faAlignBottom = {
  prefix: 'fpm',
  iconName: 'fa-align-bottom',
  icon: [
    24,
    24,
    [],
    'e001',
    'M6.76 10.54v6.54h3.92V4H6.76v6.54m7.2 2.3v4.24h3.92V8.6h-3.92v4.24M3 18.9v.5h18.64v-1H3v.5',
  ],
};
